<ion-modal #modal [trigger]="trigger" [presentingElement]="presentingElement">
	<ng-template>
		<ion-header>
			<ion-toolbar>
				<ion-title>{{'ISSUE.MODAL.TITLE' | transloco}}</ion-title>
				<ion-buttons slot="end">
					<ion-button (click)="close()" [strong]="true">{{'ISSUE.MODAL.CLOSE' | transloco}}</ion-button>
				</ion-buttons>
			</ion-toolbar>
		</ion-header>
		<ion-content class="ion-padding">
			<div class="flex flex-col">
				<ion-label class="text-2xl mb-6" *ngIf="issueTitle && showTitle">{{ issueTitle }}</ion-label>
				<ion-label *ngIf="amountBlocked">{{ 'ISSUE.BLOCKED_AMOUNT' | transloco}}</ion-label>
				<ion-label class="text-4xl" *ngIf="amountBlocked && fiatExchangeRate">
					{{ (+this.amountBlocked * +fiatExchangeRate) | currency : 'EUR' : 'symbol-narrow'}}
					<ion-label class="text-base opacity-75" color="medium">{{ this.amountBlocked | currency : 'USD' : 'symbol-narrow'}}</ion-label>
				</ion-label>
			</div>
			<div *ngIf="lockedTokenHistories" class="my-2">
				<ion-card color="light" class="p-0 m-0">
					<ion-grid class="rounded-md overflow-hidden">
						<ion-row class="border-b border-gray-300/40 text-base">
							<ion-col class="font-bold">{{ 'ISSUE.DETAIL.TOKEN' | transloco }}</ion-col>
							<ion-col class="font-bold">{{ 'ISSUE.DETAIL.IMPACT_EUR' | transloco }}</ion-col>
							<ion-col class="font-bold">{{ 'ISSUE.DETAIL.IMPACT_USD' | transloco }}</ion-col>
							<ion-col class="font-bold">{{ 'ISSUE.DETAIL.QUANTITY' | transloco }}</ion-col>
						</ion-row>
						<ion-row *ngFor="let token of lockedTokenHistories" class="border-gray-300/20 border-b last-no-border text-base">
							<ion-col>{{ token.coin.code }}</ion-col>
							<ion-col>
								{{ (+token.amountUsd * +fiatExchangeRate) | currency : 'EUR' : 'symbol-narrow' }}
							</ion-col>
							<ion-col>
								{{ token.amountUsd | currency : 'USD' : 'symbol-narrow' }}
							</ion-col>
							<ion-col>
								{{ token.coinAmount | number:'1.2-3' }}
							</ion-col>
						</ion-row>
					</ion-grid>
				</ion-card>
			</div>
			<markdown [data]="issueMessage"></markdown>
		</ion-content>
	</ng-template>
</ion-modal>